import React, { Component } from 'react';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import { LocalizedLink } from 'gatsby-theme-i18n';
import styled from 'styled-components';

import { withLocale, filterByLocale } from '../helpers';

const FooterWrapper = styled.footer`
  background-color: var(--color-dark-grey);

`;

const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 260px;
  align-items: left;
  position: relative;
  bottom: 0;
  max-width: 1920px;
  margin: auto;

  & a {
    text-decoration: none;
    font-size: 17px;
    color: var(--color-grey);

    @media (max-width: 1350px) {
      font-size: 16px;
    }

    @media (max-width: 1023px) {
      font-size: 15px;
    }
  }

  & a:hover {
    color: var(--color-white);
    cursor: pointer;
  }

  & li {
    list-style: none;
    margin-right: 18px;
    color: var(--color-grey);
  }

`;

const AddressContainer = styled.address`
  font-size: 17px;
  font-style: normal;
  line-height: 30px;
  padding-top: 30px;
  margin-right: 18px;
  
  & p:first-child {
    white-space: pre-wrap;
    color: var(--color-grey);
    margin-top: 0;
  }

  @media (max-width: 2120px) {
    margin-left: 100px;
  }

  @media (max-width: 1370px) {
    margin-left: 50px;
    padding-top: 30px;
    font-size: 16px;
  }

  @media (max-width: 1023px) {
    font-size: 15px;
  }

`;

const Copyright = styled.span`
  font-size: 12px;
  position: absolute;
  bottom: 15px;
  color: var(--color-grey);

  @media (max-width: 2120px) {
    left: 100px;
  }

  @media (max-width: 1470px) {
    line-height: 1.5;
  }

  @media (max-width: 1370px) {
    left: 50px;
  }
`;

const LinkBlock1 = styled.ul`
  display: flex;
  flex-direction: column;
  padding-top: 35px;
  margin-top: 0;
  padding-left: 0;

  & li {
    padding-bottom: 10px;
  }

  & li:first-child {
    font-weight: 700;

    @media (max-width: 920px) {
      font-size: 15px;
    }
  }

  @media (max-width: 1350px) {
    padding-top: 35px;
  }

`;

const LinkBlock2 = styled(LinkBlock1)`

`;

const CollaborationContainer = styled.div`
  position: absolute;
  display: flex;
  gap: 15px;
  top: 65px;
  right: 0;

  & img {
    width: 152px;
    height: 77px;

    @media (max-width: 1350px) {
      width: 130px;
    }
    @media (max-width: 920px) {
      width: 110px;
    }
  }

  @media (max-width: 2120px) {
    right: 100px;
  }
  
  @media (max-width: 1370px) {
    flex-direction: column;
    position: relative;
    top: 0;
    right: 0;
    padding-top: 18px;
  }
`;

const SocialMediaContainer = styled.ul`
  display: flex;
  flex-direction: row;
  gap: 15px;
  margin-top: auto;
  margin-bottom: 38px;

  @media (max-width: 2120px) {
    margin-right: 100px;
  }

  @media (max-width: 1370px) {
    margin-right: 50px;
    flex-direction: column;
    gap: 10px 15px;
    height: 60%;
    flex-wrap: wrap;
    margin-bottom: 73px;
  }

  @media (max-width: 1023px) {
    gap:15px;
  }
`;

const Icon = styled.svg`
  width: 40px;
  fill: var(--color-grey);

  &:hover{
    fill: var(--color-white);
  }

  @media (max-width: 1350px) {
    width: 35px;
  }
`;

const FooterContainerMobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  position: relative;
  bottom: 0;
  margin: auto;
  text-align: center;

  & a {
    text-decoration: none;
    font-size: 18px;
    color: var(--color-grey);
    font-weight: 900; 
  }

  & a:hover {
    color: var(--color-white);
    cursor: pointer;
  }
`;

const LinkBlockMobile = styled.ul`
  display: flex;
  flex-direction: column;
  padding-top: 35px;
  padding-inline-start: 0;

  & li {
    padding-bottom: 18px;
    list-style: none;
  }

`;

const SocialMediaContainerMobile = styled.ul`
  display: flex;
  gap: 20px;
  padding-bottom: 17px;
  margin: auto;
  padding-inline-start: 0;

   @media (max-width: 416px) {
    gap: 12px;
   }
`;

const IconMobile = styled.svg`
  width: 45px;
  fill: var(--color-grey);

  &:hover{
    fill: var(--color-white);
  }

  @media (max-width: 416px) {
    width: 40px;
  }
`;

const CollaborationContainerMobile = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 50%;
  margin: auto;
  padding: 15px 0;

  & img {
    width: 40%;
  }

  @media (max-width: 600px) {
    width: 70%;
  }

  @media (max-width: 354px) {
    width: 96%;
  }
`;

const AddressContainerMobile = styled.div`
  color: var(--color-grey);
  margin: auto;
  width: 48%;
  font-size: 16px;
  line-height: 1.5;
  word-spacing: 2px;

   & a {
    font-weight: 400;
    font-size: 16px;

    @media (max-width: 450px) {
      font-size: 15px;
    }
   }

  @media (max-width: 696px) {
    width: 63%;
  }

  @media (max-width: 530px) {
    width: 82%;
  }

  @media (max-width: 410px) {
    font-size: 15px;
    width: 100%;
  }

  @media (max-width: 354px) {
    white-space: pre-line;
  }
`;

const CopyrightMobile = styled.div`
  color: var(--color-grey);
  margin: auto;
  font-size: 11px;
  padding-bottom: 70px;
`;

class Footer extends Component {
  static propTypes = {
    locale: PropTypes.string,
    currentPath: PropTypes.string,
  };

  constructor(...params) {
    super(...params);
    this.state = {
      selectedElLink: null,
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.onResize);

      window.setTimeout(this.onResize, 100);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize);
      if (this.resizeTimeout) {
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }
  }

  onResize = () => {
    if (typeof window !== 'undefined') {
      if (this.resizeTimeout) {
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
      this.resizeTimeout = window.setTimeout(() => {
        this.forceUpdate();
      }, 500);
    }
  };

  renderMenuItem = (link, title) => {
    const { currentPath } = this.props;
    const { selectedElLink } = this.state;
    return (
      <li
        ref={(el) => {
          if (el) {
            let isActive = false;
            if (link === '/') {
              isActive = link === currentPath;
            } else {
              isActive = currentPath && currentPath.startsWith(link);
            }
            if (isActive && selectedElLink !== link) {
              this.setState({
                selectedElLink: link,
              });
            }
          }
        }}
      >
        <LocalizedLink to={link}>{title}</LocalizedLink>
      </li>
    );
  };

  renderContent = (data) => {
    const { locale } = this.props;
    const [content] = filterByLocale(data, locale);
    const tabIndexFooter = 0;

    return (
      <FooterWrapper>
        { typeof window !== 'undefined' && window.innerWidth > 900 && (
          <FooterContainer>
            <AddressContainer>
              <div>
                <MDXRenderer>{content?.node?.frontmatter?.address}</MDXRenderer>
              </div>
              <Copyright>{content?.node?.frontmatter?.copyright}</Copyright>
            </AddressContainer>
            <LinkBlock1>
              { this.renderMenuItem('/', content?.node?.frontmatter?.homepageLinkTitle) }
              { this.renderMenuItem('/blog', content?.node?.frontmatter?.blogTitleFooter) }
              { this.renderMenuItem('/onboarding', content?.node?.frontmatter?.onboardingTitleFooter) }
              { this.renderMenuItem('/apps', content?.node?.frontmatter?.appsTitle) }
              <li>
                <a href={content?.node?.frontmatter?.helpLink} target="_blank" rel="noreferrer help">{content?.node?.frontmatter?.helpTitle}</a>
              </li>
            </LinkBlock1>
            <LinkBlock2>
              <li>{ content?.node?.frontmatter?.infoTitle }</li>
              { this.renderMenuItem('/imprint', content?.node?.frontmatter?.imprintTitle) }
              { this.renderMenuItem('/privacyPolicy', content?.node?.frontmatter?.privacyPolicyTitle) }
              { this.renderMenuItem('/terms', content?.node?.frontmatter?.termsTitle) }
            </LinkBlock2>
            <CollaborationContainer>
              <img src={`/img/${content?.node?.frontmatter?.tech2bLogo}`} alt="logo-tech2b" loading="lazy" />
              <img src={`/img/${content?.node?.frontmatter?.ffgLogo}`} alt="logo-ffg" loading="lazy" />
            </CollaborationContainer>
            <SocialMediaContainer>
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.facebook.com/presono"
                tabIndex={tabIndexFooter}
              >
                <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                  <mask id="facebook">
                    <rect x="0" y="0" width="256" height="256" fill="white" />
                    {/* eslint-disable-next-line max-len */}
                    <path transform="scale(0.0185)" d="M9879 9168l315-2056H8222V5778c0-562 275-1111 1159-1111h897V2917s-814-139-1592-139c-1624 0-2686 984-2686 2767v1567H4194v2056h1806v4969c362 57 733 86 1111 86s749-30 1111-86V9168z" fill="black" />
                  </mask>
                  <rect x="0" y="0" width="256" height="256" rx="48" ry="48" mask="url(#facebook)" />
                </Icon>
              </a>
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.instagram.com/_presono"
                tabIndex={tabIndexFooter}
              >
                <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                  <mask id="instagram">
                    <rect x="0" y="0" width="256" height="256" fill="white" />
                    {/* eslint-disable-next-line max-len */}
                    <path transform="scale(0.97)" d="M132.3452 33.973c-26.7167 0-30.0696.1167-40.5629.5939-10.4727.4792-17.6212 2.136-23.8762 4.567-6.4701 2.5107-11.9586 5.8693-17.4265 11.3352-5.472 5.464-8.8332 10.9483-11.354 17.4116-2.4389 6.2524-4.099 13.3976-4.5703 23.8585-.4693 10.4854-.5923 13.8379-.5923 40.5348 0 26.697.1189 30.0371.5943 40.5225.4817 10.465 2.1397 17.6082 4.5703 23.8585 2.5147 6.4654 5.8758 11.9497 11.3458 17.4136 5.466 5.468 10.9544 8.8349 17.4204 11.3456 6.259 2.4309 13.4097 4.0877 23.8803 4.567 10.4933.477 13.8441.5938 40.5588.5938 26.7188 0 30.0615-.1167 40.5547-.5939 10.4728-.4792 17.6295-2.136 23.8885-4.567 6.4681-2.5106 11.9484-5.8775 17.4143-11.3455 5.472-5.4639 8.8332-10.9482 11.354-17.4115 2.4183-6.2524 4.0784-13.3976 4.5703-23.8585.4713-10.4854.5943-13.8277.5943-40.5246 0-26.697-.123-30.0473-.5943-40.5328-.4919-10.465-2.152-17.6081-4.5703-23.8584-2.5208-6.4654-5.882-11.9498-11.354-17.4137-5.4721-5.468-10.9442-8.8266-17.4204-11.3353-6.2714-2.4309-13.424-4.0877-23.8967-4.5669-10.4933-.4772-13.8339-.5939-40.5588-.5939zm-8.825 17.7147c2.6193-.0041 5.5418 0 8.825 0 26.2659 0 29.379.0942 39.7513.5652 9.5915.4383 14.7971 2.0397 18.2648 3.3852 4.5908 1.7817 7.8638 3.9116 11.3048 7.3521 3.4431 3.4406 5.5745 6.7173 7.3617 11.3046 1.3465 3.461 2.9512 8.6628 3.3877 18.2472.4714 10.3625.5739 13.4754.5739 39.7095 0 26.234-.1025 29.347-.5739 39.7095-.4386 9.5843-2.0412 14.7861-3.3877 18.2471-1.783 4.5874-3.9186 7.8539-7.3617 11.2923-3.443 3.4406-6.712 5.5704-11.3048 7.3521-3.4636 1.3517-8.6733 2.949-18.2648 3.3873-10.3702.471-13.4854.5734-39.7513.5734-26.2679 0-29.381-.1024-39.7513-.5734-9.5914-.4423-14.797-2.0438-18.2668-3.3893-4.5908-1.7817-7.87-3.9116-11.313-7.3521-3.4431-3.4405-5.5745-6.709-7.3617-11.2985-1.3465-3.461-2.9512-8.6628-3.3877-18.2471-.4714-10.3626-.5657-13.4754-.5657-39.7259 0-26.2504.0943-29.347.5657-39.7095.4386-9.5844 2.0412-14.7861 3.3877-18.2512 1.783-4.5874 3.9186-7.8641 7.3617-11.3046 3.443-3.4406 6.7222-5.5704 11.313-7.3562 3.4677-1.3517 8.6754-2.949 18.2668-3.3894 9.075-.4096 12.5919-.5324 30.9264-.553zm61.3363 16.322c-6.5173 0-11.805 5.2776-11.805 11.792 0 6.5125 5.2877 11.7962 11.805 11.7962 6.5172 0 11.8049-5.2837 11.8049-11.7962 0-6.5124-5.2877-11.796-11.805-11.796zm-52.5113 13.7826c-27.8993 0-50.5191 22.6031-50.5191 50.4817 0 27.8786 22.6198 50.4714 50.5191 50.4714s50.511-22.5928 50.511-50.4714c0-27.8786-22.6137-50.4817-50.513-50.4817zm0 17.7147c18.109 0 32.7914 14.6694 32.7914 32.767 0 18.0956-14.6824 32.767-32.7914 32.767-18.111 0-32.7913-14.6714-32.7913-32.767 0-18.0976 14.6803-32.767 32.7913-32.767z" fill="black" />
                  </mask>
                  <rect x="0" y="0" width="256" height="256" rx="48" ry="48" mask="url(#instagram)" />
                </Icon>
              </a>
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.linkedin.com/company/presono/"
                tabIndex={tabIndexFooter}
              >
                <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                  <mask id="linkedin">
                    <rect x="0" y="0" width="256" height="256" fill="white" />
                    <g transform="translate(52 96) scale(6) translate(-111 -13)">
                      <path d="M111.4,13.5h5.34V30.68H111.4ZM114.08,5a3.1,3.1,0,1,1-3.1,3.1,3.1,3.1,0,0,1,3.1-3.1" fill="black" />
                      {/* eslint-disable-next-line max-len */}
                      <path d="M120.1,13.5h5.12v2.35h.07a5.61,5.61,0,0,1,5.05-2.77c5.41,0,6.4,3.56,6.4,8.18v9.42h-5.34V22.32c0-2,0-4.56-2.78-4.56s-3.2,2.17-3.2,4.41v8.5H120.1Z" fill="black" />
                    </g>
                  </mask>
                  <rect x="0" y="0" width="256" height="256" rx="48" ry="48" mask="url(#linkedin)" />
                </Icon>
              </a>
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.xing.com/pages/presonogmbh"
                tabIndex={tabIndexFooter}
              >
                <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                  <mask id="xing">
                    <rect x="0" y="0" width="256" height="256" fill="white" />
                    <g transform="translate(52 38) scale(1.6) translate(-320 0)">
                      {/* eslint-disable-next-line max-len */}
                      <path d="m 394.74964,-0.15730337 c -2.24353,0 -3.58965,1.34611977 -4.48706,3.14094627 0,0 -34.55041,61.4728061 -35.89653,63.2676321 l 22.88404,41.729715 c 0.89741,1.34612 2.24353,3.14095 4.48706,3.14095 h 16.15344 c 0.89741,0 1.79483,-0.44871 2.24353,-0.89741 0.44871,-0.89742 0.44871,-1.79483 0,-2.69224 L 377.69879,66.251275 413.14662,3.4323495 c 0.4487,-0.8974132 0.4487,-1.7948265 0,-2.69223967 -0.44871,-0.4487066 -1.34612,-0.8974132 -2.24354,-0.8974132 z" fill="black" />
                      {/* eslint-disable-next-line max-len */}
                      <path d="m 327.44365,21.829321 c -0.89741,0 -1.79482,0.448707 -2.24353,0.897413 -0.44871,0.897413 -0.44871,1.794827 0,2.69224 l 10.76896,18.845677 -16.60215,30.063343 c -0.4487,0.897414 -0.4487,1.794827 0,2.69224 0.44871,0.448707 1.34612,0.897413 2.24354,0.897413 h 15.70473 c 2.24353,0 3.58965,-1.794826 4.48706,-3.140946 0,0 16.60215,-29.614636 17.49956,-30.51205 L 348.08416,24.970267 c -0.89742,-1.34612 -2.24354,-3.140946 -4.48707,-3.140946 z" fill="black" />
                    </g>
                  </mask>
                  <rect x="0" y="0" width="256" height="256" rx="48" ry="48" mask="url(#xing)" />
                </Icon>
              </a>
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.youtube.com/channel/UCjJoIsOqQIfN-GMhG-YUbVQ"
                tabIndex={tabIndexFooter}
              >
                <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                  <mask id="youtube">
                    <rect x="0" y="0" width="256" height="256" fill="white" />
                    <g transform="translate(49 74) scale(5.6)">
                      {/* eslint-disable-next-line max-len */}
                      <path d="M27.9727 3.12324C27.6435 1.89323 26.6768 0.926623 25.4468 0.597366C23.2197 2.24288e-07 14.285 0 14.285 0C14.285 0 5.35042 2.24288e-07 3.12323 0.597366C1.89323 0.926623 0.926623 1.89323 0.597366 3.12324C2.24288e-07 5.35042 0 10 0 10C0 10 2.24288e-07 14.6496 0.597366 16.8768C0.926623 18.1068 1.89323 19.0734 3.12323 19.4026C5.35042 20 14.285 20 14.285 20C14.285 20 23.2197 20 25.4468 19.4026C26.6768 19.0734 27.6435 18.1068 27.9727 16.8768C28.5701 14.6496 28.5701 10 28.5701 10C28.5701 10 28.5677 5.35042 27.9727 3.12324Z" fill="black" />
                      <path d="M11.4253 14.2854L18.8477 10.0004L11.4253 5.71533V14.2854Z" fill="white" />
                    </g>
                  </mask>
                  <rect x="0" y="0" width="256" height="256" rx="48" ry="48" mask="url(#youtube)" />
                </Icon>
              </a>
            </SocialMediaContainer>
          </FooterContainer>
        )}
        { typeof window !== 'undefined' && window.innerWidth <= 900 && (
          <FooterContainerMobile>
            <LinkBlockMobile>
              { this.renderMenuItem('/blog', content?.node?.frontmatter?.blogTitleFooter) }
              { this.renderMenuItem('/onboarding', content?.node?.frontmatter?.onboardingTitleFooter) }
              <li>
                <a href={content?.node?.frontmatter?.helpLink} target="_blank" rel="noreferrer help">{content?.node?.frontmatter?.helpTitle}</a>
              </li>
              { this.renderMenuItem('/imprint', content?.node?.frontmatter?.imprintTitle) }
              { this.renderMenuItem('/privacyPolicy', content?.node?.frontmatter?.privacyPolicyTitle) }
              { this.renderMenuItem('/terms', content?.node?.frontmatter?.termsTitle) }
            </LinkBlockMobile>
            <SocialMediaContainerMobile>
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.facebook.com/presono"
                tabIndex={tabIndexFooter}
              >
                <IconMobile xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                  <mask id="facebook">
                    <rect x="0" y="0" width="256" height="256" fill="white" />
                    {/* eslint-disable-next-line max-len */}
                    <path transform="scale(0.0185)" d="M9879 9168l315-2056H8222V5778c0-562 275-1111 1159-1111h897V2917s-814-139-1592-139c-1624 0-2686 984-2686 2767v1567H4194v2056h1806v4969c362 57 733 86 1111 86s749-30 1111-86V9168z" fill="black" />
                  </mask>
                  <rect x="0" y="0" width="256" height="256" rx="48" ry="48" mask="url(#facebook)" />
                </IconMobile>
              </a>
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.instagram.com/_presono"
                tabIndex={tabIndexFooter}
              >
                <IconMobile xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                  <mask id="instagram">
                    <rect x="0" y="0" width="256" height="256" fill="white" />
                    {/* eslint-disable-next-line max-len */}
                    <path transform="scale(0.97)" d="M132.3452 33.973c-26.7167 0-30.0696.1167-40.5629.5939-10.4727.4792-17.6212 2.136-23.8762 4.567-6.4701 2.5107-11.9586 5.8693-17.4265 11.3352-5.472 5.464-8.8332 10.9483-11.354 17.4116-2.4389 6.2524-4.099 13.3976-4.5703 23.8585-.4693 10.4854-.5923 13.8379-.5923 40.5348 0 26.697.1189 30.0371.5943 40.5225.4817 10.465 2.1397 17.6082 4.5703 23.8585 2.5147 6.4654 5.8758 11.9497 11.3458 17.4136 5.466 5.468 10.9544 8.8349 17.4204 11.3456 6.259 2.4309 13.4097 4.0877 23.8803 4.567 10.4933.477 13.8441.5938 40.5588.5938 26.7188 0 30.0615-.1167 40.5547-.5939 10.4728-.4792 17.6295-2.136 23.8885-4.567 6.4681-2.5106 11.9484-5.8775 17.4143-11.3455 5.472-5.4639 8.8332-10.9482 11.354-17.4115 2.4183-6.2524 4.0784-13.3976 4.5703-23.8585.4713-10.4854.5943-13.8277.5943-40.5246 0-26.697-.123-30.0473-.5943-40.5328-.4919-10.465-2.152-17.6081-4.5703-23.8584-2.5208-6.4654-5.882-11.9498-11.354-17.4137-5.4721-5.468-10.9442-8.8266-17.4204-11.3353-6.2714-2.4309-13.424-4.0877-23.8967-4.5669-10.4933-.4772-13.8339-.5939-40.5588-.5939zm-8.825 17.7147c2.6193-.0041 5.5418 0 8.825 0 26.2659 0 29.379.0942 39.7513.5652 9.5915.4383 14.7971 2.0397 18.2648 3.3852 4.5908 1.7817 7.8638 3.9116 11.3048 7.3521 3.4431 3.4406 5.5745 6.7173 7.3617 11.3046 1.3465 3.461 2.9512 8.6628 3.3877 18.2472.4714 10.3625.5739 13.4754.5739 39.7095 0 26.234-.1025 29.347-.5739 39.7095-.4386 9.5843-2.0412 14.7861-3.3877 18.2471-1.783 4.5874-3.9186 7.8539-7.3617 11.2923-3.443 3.4406-6.712 5.5704-11.3048 7.3521-3.4636 1.3517-8.6733 2.949-18.2648 3.3873-10.3702.471-13.4854.5734-39.7513.5734-26.2679 0-29.381-.1024-39.7513-.5734-9.5914-.4423-14.797-2.0438-18.2668-3.3893-4.5908-1.7817-7.87-3.9116-11.313-7.3521-3.4431-3.4405-5.5745-6.709-7.3617-11.2985-1.3465-3.461-2.9512-8.6628-3.3877-18.2471-.4714-10.3626-.5657-13.4754-.5657-39.7259 0-26.2504.0943-29.347.5657-39.7095.4386-9.5844 2.0412-14.7861 3.3877-18.2512 1.783-4.5874 3.9186-7.8641 7.3617-11.3046 3.443-3.4406 6.7222-5.5704 11.313-7.3562 3.4677-1.3517 8.6754-2.949 18.2668-3.3894 9.075-.4096 12.5919-.5324 30.9264-.553zm61.3363 16.322c-6.5173 0-11.805 5.2776-11.805 11.792 0 6.5125 5.2877 11.7962 11.805 11.7962 6.5172 0 11.8049-5.2837 11.8049-11.7962 0-6.5124-5.2877-11.796-11.805-11.796zm-52.5113 13.7826c-27.8993 0-50.5191 22.6031-50.5191 50.4817 0 27.8786 22.6198 50.4714 50.5191 50.4714s50.511-22.5928 50.511-50.4714c0-27.8786-22.6137-50.4817-50.513-50.4817zm0 17.7147c18.109 0 32.7914 14.6694 32.7914 32.767 0 18.0956-14.6824 32.767-32.7914 32.767-18.111 0-32.7913-14.6714-32.7913-32.767 0-18.0976 14.6803-32.767 32.7913-32.767z" fill="black" />
                  </mask>
                  <rect x="0" y="0" width="256" height="256" rx="48" ry="48" mask="url(#instagram)" />
                </IconMobile>
              </a>
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.linkedin.com/company/presono/"
                tabIndex={tabIndexFooter}
              >
                <IconMobile xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                  <mask id="linkedin">
                    <rect x="0" y="0" width="256" height="256" fill="white" />
                    <g transform="translate(52 96) scale(6) translate(-111 -13)">
                      <path d="M111.4,13.5h5.34V30.68H111.4ZM114.08,5a3.1,3.1,0,1,1-3.1,3.1,3.1,3.1,0,0,1,3.1-3.1" fill="black" />
                      {/* eslint-disable-next-line max-len */}
                      <path d="M120.1,13.5h5.12v2.35h.07a5.61,5.61,0,0,1,5.05-2.77c5.41,0,6.4,3.56,6.4,8.18v9.42h-5.34V22.32c0-2,0-4.56-2.78-4.56s-3.2,2.17-3.2,4.41v8.5H120.1Z" fill="black" />
                    </g>
                  </mask>
                  <rect x="0" y="0" width="256" height="256" rx="48" ry="48" mask="url(#linkedin)" />
                </IconMobile>
              </a>
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.xing.com/pages/presonogmbh"
                tabIndex={tabIndexFooter}
              >
                <IconMobile xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                  <mask id="xing">
                    <rect x="0" y="0" width="256" height="256" fill="white" />
                    <g transform="translate(52 38) scale(1.6) translate(-320 0)">
                      {/* eslint-disable-next-line max-len */}
                      <path d="m 394.74964,-0.15730337 c -2.24353,0 -3.58965,1.34611977 -4.48706,3.14094627 0,0 -34.55041,61.4728061 -35.89653,63.2676321 l 22.88404,41.729715 c 0.89741,1.34612 2.24353,3.14095 4.48706,3.14095 h 16.15344 c 0.89741,0 1.79483,-0.44871 2.24353,-0.89741 0.44871,-0.89742 0.44871,-1.79483 0,-2.69224 L 377.69879,66.251275 413.14662,3.4323495 c 0.4487,-0.8974132 0.4487,-1.7948265 0,-2.69223967 -0.44871,-0.4487066 -1.34612,-0.8974132 -2.24354,-0.8974132 z" fill="black" />
                      {/* eslint-disable-next-line max-len */}
                      <path d="m 327.44365,21.829321 c -0.89741,0 -1.79482,0.448707 -2.24353,0.897413 -0.44871,0.897413 -0.44871,1.794827 0,2.69224 l 10.76896,18.845677 -16.60215,30.063343 c -0.4487,0.897414 -0.4487,1.794827 0,2.69224 0.44871,0.448707 1.34612,0.897413 2.24354,0.897413 h 15.70473 c 2.24353,0 3.58965,-1.794826 4.48706,-3.140946 0,0 16.60215,-29.614636 17.49956,-30.51205 L 348.08416,24.970267 c -0.89742,-1.34612 -2.24354,-3.140946 -4.48707,-3.140946 z" fill="black" />
                    </g>
                  </mask>
                  <rect x="0" y="0" width="256" height="256" rx="48" ry="48" mask="url(#xing)" />
                </IconMobile>
              </a>
              <a
                rel="noreferrer"
                target="_blank"
                href="https://www.youtube.com/channel/UCjJoIsOqQIfN-GMhG-YUbVQ"
                tabIndex={tabIndexFooter}
              >
                <IconMobile xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                  <mask id="youtube">
                    <rect x="0" y="0" width="256" height="256" fill="white" />
                    <g transform="translate(49 74) scale(5.6)">
                      {/* eslint-disable-next-line max-len */}
                      <path d="M27.9727 3.12324C27.6435 1.89323 26.6768 0.926623 25.4468 0.597366C23.2197 2.24288e-07 14.285 0 14.285 0C14.285 0 5.35042 2.24288e-07 3.12323 0.597366C1.89323 0.926623 0.926623 1.89323 0.597366 3.12324C2.24288e-07 5.35042 0 10 0 10C0 10 2.24288e-07 14.6496 0.597366 16.8768C0.926623 18.1068 1.89323 19.0734 3.12323 19.4026C5.35042 20 14.285 20 14.285 20C14.285 20 23.2197 20 25.4468 19.4026C26.6768 19.0734 27.6435 18.1068 27.9727 16.8768C28.5701 14.6496 28.5701 10 28.5701 10C28.5701 10 28.5677 5.35042 27.9727 3.12324Z" fill="black" />
                      <path d="M11.4253 14.2854L18.8477 10.0004L11.4253 5.71533V14.2854Z" fill="white" />
                    </g>
                  </mask>
                  <rect x="0" y="0" width="256" height="256" rx="48" ry="48" mask="url(#youtube)" />
                </IconMobile>
              </a>
            </SocialMediaContainerMobile>
            <CollaborationContainerMobile>
              <img src={`/img/${content?.node?.frontmatter?.tech2bLogo}`} alt="logo-tech2b" loading="lazy" />
              <img src={`/img/${content?.node?.frontmatter?.ffgLogo}`} alt="logo-ffg" loading="lazy" />
            </CollaborationContainerMobile>
            <AddressContainerMobile>
              <div>
                <MDXRenderer>{content?.node?.frontmatter?.address}</MDXRenderer>
              </div>
            </AddressContainerMobile>
            <CopyrightMobile>{content?.node?.frontmatter?.copyright}</CopyrightMobile>
          </FooterContainerMobile>
        )}
      </FooterWrapper>
    );
  };

  render() {
    return (
      <StaticQuery
        query={graphql`
          query FooterQuery {
            allMdx(filter: {frontmatter: {layout: {eq: "footer"}}}) {
              edges {
                node {
                  frontmatter {
                    layout
                    address
                    copyright
                    homepageLinkTitle
                    onboardingTitleFooter
                    blogTitleFooter
                    infoTitle
                    appsTitle
                    helpTitle
                    helpLink
                    imprintTitle
                    privacyPolicyTitle
                    termsTitle
                    tech2bLogo
                    ffgLogo
                  }
                  fields {
                    locale
                  }
                }

              }
            }
          }
        `}
        render={this.renderContent}
      />
    );
  }
}

const LocalizedFooter = withLocale(Footer);

export default LocalizedFooter;
